import React, { useMemo } from 'react';
import { copy } from './array';

const titleNames = ['place', 'username', 'spins', 'score'];

const renderTitle = (title, i) => (
  <th className={`tournaments__lobby__players-title ${title}`} key={i}>{title}</th>
);

export const renderPlayer = ({ id, place, name, spins, score, self }, classes) => (
  <tr className={`tournaments__lobby__player ${classes} ${self ? 'hero-player' : ''}`} key={id}>
    <td className="tournaments__lobby__player-cell place">{place}</td>
    <td className="tournaments__lobby__player-cell name">{name}</td>
    <td className="tournaments__lobby__player-cell spins">{spins}</td>
    <td className="tournaments__lobby__player-cell score">{Math.floor(score)}</td>
  </tr>
);

export const renderTournamentPlayersList = (playerList, t, showMorePlayersMobile = false, showPlayerPosition) => {
  const player = playerList.find(s => s.self);
  const emptyRows = useMemo(() => {
    if (playerList.length >= 18) return [];
    return copy(18 - playerList.length, (i) => (
      <tr className="tournaments__lobby__players-empty tournaments__lobby__player" key={i + 100000}>
        <td colSpan="4" className="tournaments__lobby__player-cell" />
      </tr>
    ));
  }, [playerList]);

  const showPlayerListForMobile = [...playerList].slice(0, 3)
  const showMorePlayerListForMobile = [...playerList].slice(3)


  return (

    <table className="tournaments__lobby__players">
      <tbody>
        <tr className="tournaments__lobby__players-head">
          {titleNames.map((titleName, i) => renderTitle(t(titleName), i))}
        </tr>
        <React.Fragment>
          {showPlayerListForMobile.map(renderPlayer)}
          {showMorePlayersMobile && showMorePlayerListForMobile.map(renderPlayer)}
        </React.Fragment>
        {showPlayerPosition &&
          renderPlayer(player, "hero-player__position")
        }
      </tbody>
    </table>
  )
}